interface ToggleProps {
  on: boolean;
  onChange: (next: boolean) => void;
  label?: string; // for screen readers when standalone
}

export function Toggle({ on, onChange, label }: ToggleProps) {
  return (
    <button
      role="switch"
      aria-checked={on}
      aria-label={label}
      onClick={() => onChange(!on)}
      className="rounded-full relative transition-colors"
      style={{
        width: "32px",
        height: "18px",
        background: on ? "var(--color-copper)" : "var(--color-mist)",
        cursor: "pointer",
        border: "none",
      }}
    >
      <span
        className="absolute rounded-full transition-all"
        style={{
          width: "14px",
          height: "14px",
          top: "2px",
          left: on ? "16px" : "2px",
          background: "white",
          boxShadow: "0 1px 2px rgba(0,0,0,0.18)",
        }}
      />
    </button>
  );
}
